export class NameValueDto {
    constructor(
        public code?: String,
        public name?: String
    ) {
    }
}
